import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const normalizeLanguage = (value) =>
  String(value || "fa").toLowerCase().startsWith("en") ? "en" : "fa";

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get from localStorage or default to Persian
    const saved = localStorage.getItem("lavvissa_language");
    return normalizeLanguage(saved);
  });

  useEffect(() => {
    localStorage.setItem("lavvissa_language", language);
    document.documentElement.lang = language;
    // Keep direction scoped to components; a global RTL root breaks the landing's
    // horizontal GSAP measurements in Safari.
  }, [language]);

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "fa" ? "en" : "fa"));
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    isRTL: language === "fa",
  };

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export default LanguageContext;


